export interface CandidateViewState {
  activeTab:
    | "overview"
    | "experience"
    | "education"
    | "skills"
    | "projects"
    | "certifications"
    | "additional";
}
export const initialCandidateViewState: CandidateViewState = {
  activeTab: "overview",
};
export type CandidateViewAction = {
  type: "SET_ACTIVE_TAB";
  payload: CandidateViewState["activeTab"];
};
